import styled, { css } from 'styled-components';
import { NEUTRAL_300 } from '../../styles/colors';
import { BODY_NORMAL_BOLD } from '../../styles/typography';
import { isAmazonHost } from '../../utils';

export const Description = styled.span`
  color: ${NEUTRAL_300};
  ${BODY_NORMAL_BOLD};
  padding-top: 16px;
`;

export const TerminalsRadioGroup = styled.div`
    font-family: 'rs-iconfont', Equip, Helvetica, Arial, sans-serif !important;
    
    ${() => isAmazonHost() && css`
      font-family: 'rs-iconfont', Amazon Ember, Helvetica, Arial, sans-serif !important;
    `}
`;
